import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ShopByHeaderSection from 'components/consumer/ShopByHeaderSection';
import TogglePillGroup from 'components/consumer/TogglePillGroup';
import useUpholsteryFilteredEvent from 'data-hooks/useEvents/useUpholsteryFilteredEvent';
const fabricFeatures = {
  pet_friendly: 'Kid + Pet Friendly',
  velvet: 'Velvets',
  safeguard: 'Safeguard',
  sustainable_fabric: 'Sustainable',
  greenguard_gold: 'GREENGUARD Gold',
  pantone: 'PANTONE™'
};
const eventValue = {
  pet_friendly: 'pet-friendly',
  safeguard: 'safeguard',
  sustainable_fabric: 'sustainable-fabric',
  velvet: 'velvet',
  greenguard_gold: 'geenguard-gold',
  pantone: 'pantone_flag'
};
const FeaturesFilters = t0 => {
  const $ = _c(11);
  const {
    toggleSelectedFeature,
    selectedFeatures,
    selectedFabric
  } = t0;
  let t1;
  bb0: {
    if (selectedFabric) {
      let t2;
      if ($[0] !== selectedFabric.option.type) {
        t2 = {
          name: selectedFabric.option.type
        };
        $[0] = selectedFabric.option.type;
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      let t3;
      if ($[2] !== selectedFabric.footerTitle.name || $[3] !== selectedFabric.option.id || $[4] !== t2) {
        t3 = {
          id: selectedFabric.option.id,
          name: selectedFabric.footerTitle.name,
          type: t2
        };
        $[2] = selectedFabric.footerTitle.name;
        $[3] = selectedFabric.option.id;
        $[4] = t2;
        $[5] = t3;
      } else {
        t3 = $[5];
      }
      t1 = t3;
      break bb0;
    }
    t1 = null;
  }
  const basicDetails = t1;
  const {
    upholsteryFilteredEvent
  } = useUpholsteryFilteredEvent(basicDetails, null, null, "Swatches");
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Object.keys(fabricFeatures);
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== selectedFeatures || $[8] !== toggleSelectedFeature || $[9] !== upholsteryFilteredEvent) {
    t3 = <ShopByHeaderSection label="Features"><div><TogglePillGroup items={t2.map(feature => ({
          label: fabricFeatures[feature],
          id: feature,
          onClick: () => {
            toggleSelectedFeature(feature);
            if (!selectedFeatures[feature]) {
              upholsteryFilteredEvent(eventValue[feature], null, null);
            }
          },
          isSelected: selectedFeatures[feature]
        }))} variant="ShopByHeaderSection" /></div></ShopByHeaderSection>;
    $[7] = selectedFeatures;
    $[8] = toggleSelectedFeature;
    $[9] = upholsteryFilteredEvent;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
FeaturesFilters.propTypes = {
  toggleSelectedFeature: PropTypes.func,
  selectedFeatures: PropTypes.node,
  selectedFabric: PropTypes.object
};
export default FeaturesFilters;